module.exports = "/wwwroot/img/asterisk-solid.svg?ver=67776121";